import React from "react";

const Privacy = () => {
  return (
    <div className="div" id="privacy">
      <div className="privacy">
        <h2>Privacy Policy</h2>
        <p>
          By using this website as a user (hereafter “You”), You agree to the
          following Privacy Policy. Please read this policy carefully before
          using this website.
        </p>

        <p>
          This website is owned and operated by a Montana company (hereafter
          “Our”, “We”). Our principal place of business is located in Missoula,
          Montana.
        </p>

        <p>
          Kee Move, LLC, is a registered limited liability corporation in
          Montana, USA.
        </p>

        <p>
          For any privacy-related questions, you can reach us at{" "}
          <a href="mailto:office@keemove.com"> office@keemove.com</a>.
        </p>

        <h2>GENERAL</h2>

        <p>
          We at Kee Move, LLC respect Your privacy. This Privacy Policy is
          designed to explain how We collect, use, share, and protect the
          personal information You provide to us when You access Our website,
          purchase Our goods or services, or engage with us on social media, as
          well as Your own rights to the information We collect.
        </p>

        <p>
          Please read this Privacy Policy carefully. We will alert You to any
          changes to this Policy by changing the “last updated” date at the top
          of this Policy. Any changes become effective immediately upon
          publication on Our website, and You waive specific notice of any
          changes to the Policy by continuing to use and access Our site(s). We
          encourage You to review this Privacy Policy periodically, when You use
          Our website for any purpose or engage with us on social media. You are
          deemed to have accepted any changes to any revised Privacy Policy by
          Your continued use of Our website after the revised Privacy Policy is
          posted.
        </p>
        <h2>INFORMATION THAT WE COLLECT</h2>

        <p>
          We collect a variety of information from You when You visit Our
          website, make purchases, or interact with us on social media. By
          accepting this Privacy Policy, You are specifically consenting to Our
          collection of the data described below, to Our use of the data, to the
          processing of this data, and to Our sharing of the data with third
          party processors as needed for Our legitimate business interests The
          information We collect may include:
        </p>

        <p>
          <strong>Personal Data:</strong> Personal Data is information that can
          be used to identify You specifically, including Your name, shipping
          address, email address, telephone number or demographic information
          like Your age, gender, or hometown. You consent to giving us this
          information by providing it to us voluntarily on Our website or any
          mobile application. You provide some of this information when You
          register with or make purchases from Our website. You may also provide
          this information by participating in various activities associated
          with Our site, including responding to blogs or contacting us with
          questions. Your decision to disclose this data is entirely voluntary.
          You are under no obligation to provide this information, but Your
          refusal may prevent You from accessing certain benefits from Our
          website or from making purchases.
        </p>

        <p>
          <strong>Derivative Data:</strong> Derivative data is information that
          Our servers automatically collect about You when You access Our
          website, such as Your IP address, browser type, the dates and times
          that You access Our website, and the specific pages You view. If You
          are using a mobile application, Our servers may collect information
          about Your device name and type, Your phone number, Your country of
          origin, and other interactions with Our application.
        </p>

        <p>
          <strong>Financial Data:</strong> Financial data is data that is
          related to Your payment method, such as credit card or bank transfer
          details. We collect financial data in order to allow You to purchase,
          order, return or exchange products or services from Our website and
          any related mobile apps. We store limited financial data. Most
          financial data is transferred to Our payment processor, Fusion Web
          Clinic, Etsy, Teachers Pay Teachers, Paypal, and Venmo, and You should
          review these processors’ Privacy Policy to determine how they use,
          disclose and protect Your financial data.
        </p>

        <p>
          <strong>Social Networking Data:</strong> We may access personal
          information from social networking sites and apps, including Facebook,
          Instagram, Linkedin, Twitter, Snapchat or other social networking
          sites or apps not named specifically here, which may include Your
          name, Your social network username, location, email address, age,
          gender, profile picture and any other public information. If You do
          not want us to access this information, please go to the specific
          social networking site and change Your privacy settings.
        </p>

        <p>
          <strong>Mobile Device Data: </strong>
          If You use Our website via a mobile device or app, We may collect
          information about Your mobile device, including device ID, model and
          manufacturer, and location information. Mobile information will not be
          shared with third parties/affiliates for marketing/promotional
          purposes. All the above categories exclude text messaging originator
          opt-in data and consent; this information will not be shared with any
          third parties.
        </p>
        <p>
          <strong>Other data: </strong>
          On occasion, You may give us additional data in order to enter into a
          contest or giveaway or to participate in a survey. You will be
          prompted for this information and it will be clear that You are
          offering this kind of information in exchange for an entry into such a
          contest or giveaway.
        </p>

        {/* chat */}

        {/* chat stop */}

        <h2>HOW WE USE YOUR INFORMATION</h2>
        <p>
          Your information allows us to offer You certain products and services,
          including the use of Our website, to fulfill Our obligations to You,
          to customize Your interaction with Our company and Our website, and to
          allow us to suggest other products and services We think might
          interest You. We generally store Your data and transmit it to a third
          party for processing. However, to the extent We process Your data, We
          do so to serve Our legitimate business interests (such as providing
          You with the opportunity to purchase Our goods or services and
          interact with Our website).
        </p>

        <h2>
          Specifically, We may use the information and data described above to:
        </h2>
        <ul>
          <li>Create and administer Your account; and</li>
          <li>Deliver any products or services purchased by You to You; and</li>
          <li>Correspond with You; and</li>
          <li>Process payments or refunds; and</li>
          <li>
            Contact You about new offerings that We think You will be interested
            in; and
          </li>
          <li>Interact with You via social media; and</li>
          <li>
            Send You a newsletter or other updates about Our company or website;
            and
          </li>
          <li>Deliver targeted advertising; and</li>
          <li>Request feedback from You; and</li>
          <li>
            Notify You of updates to Our product and service offerings; and
          </li>
          <li>Resolve disputes and troubleshoot any problems; and</li>
          <li>Administer contests or giveaways; and</li>
          <li>
            Generate a profile that is personalized to You, so that future
            interactions with Our website will be more personal; and
          </li>
          <li>
            Compile anonymous statistical data for Our own use or for a third
            party’s use; and
          </li>
          <li>Assist law enforcement as necessary; and</li>
          <li>Prevent fraudulent activity on Our website or mobile app; and</li>
          <li>Analyze trends to improve Our website and offerings.</li>
        </ul>

        <h2>How We Share</h2>
        <p>
          No mobile information will be shared with third parties/affiliates
          for marketing/promotional purposes.
        </p>

        <h2>WHY WE DISCLOSE YOUR INFORMATION</h2>
        <p>
          We may share Your information with third parties in certain
          situations. In particular, We may share Your data with third party
          processors as needed to serve Our legitimate business interests, which
          include administration of Our website, administration of Your account,
          entering into contracts with You, communicating with You, taking
          orders for goods or services, delivering Our goods and services,
          identifying trends, protecting the security of Our company and
          website, and marketing additional goods and services to You. The legal
          basis for Our disclosure of Your data is both Your Consent to this
          Privacy Policy and Our own right to protect and promote Our legitimate
          business interests.
        </p>

        <p>
          <strong>
            {" "}
            The following are specific reasons why We may share Your
            information.
          </strong>
        </p>

        <p>
          <strong>Third Party Processing:</strong>
          We may disclose Your information to third parties who assist us with
          various tasks, including payment processing, hosting services, email
          delivery and customer service. For more information, see the “Third
          Party Processing” Section below.
        </p>

        <p>
          <strong>By Law:</strong>
          We may share Your data as required by law or to respond to legal
          process, including a subpoena, or as necessary to protect the rights,
          property, and safety of others. This includes sharing information with
          other parties to prevent or address fraud and to avoid credit risks.
        </p>

        <p>
          <strong>To Protect Our Company:</strong>
          We may use Your information to protect Our company, including to
          investigate and remedy any violations of Our rights or policies. We
          may also disclose Your information as reasonably necessary to acquire
          and maintain insurance coverage, manage risks, obtain financial or
          legal advice, or to exercise or defend against legal claims.
        </p>

        <p>
          <strong>Advertisers:</strong>
          We may use third party advertising companies to run and manage Our ads
          to produce ads that appears when You visit Our Website or mobile app.
          These companies may use information about Your visit to Our website
          and other websites that are contained in web cookies (as described
          below) to offer You personalized advertisements about goods and
          services that might interest You. We cannot control the activities of,
          such other advertisers or web sites. You should consult the respective
          Privacy Policies of these third-party advertisers for more detailed
          information on their practices as well as for instructions about how
          to opt-out of certain practices.
        </p>

        <p>
          <strong>Other Third Parties:</strong>
          We may share information with advertisers, Our investors, or other
          third parties for the purpose of conducting general business analysis.
          If We do so, We will make reasonable efforts to inform You if required
          by law.
        </p>

        <p>
          <strong>Sale or Bankruptcy:</strong>
          In the event that Our company is sold, goes out of business or enters
          bankruptcy, Your information may be an asset that is transferred to a
          third party successor. Such a successor is not bound by Our Privacy
          Policy and may have its own. You will be notified in the event Our
          Company is sold, goes out of business or enters bankruptcy.
        </p>

        <p>
          <strong>Interaction with others:</strong>
          If You interact with others on Our website or mobile app, such as
          participating in a group chat or a group online course, other users
          may have access to some of Your data, including Your name, profile
          picture, and Your history of interaction with Our website, such as
          prior comments or posts.
        </p>

        <p>
          <strong>Online postings:</strong>
          When You post online, Your posts may be viewed by others, and We may
          distribute Your comments outside the website.
        </p>

        <p>
          <strong>External Links:</strong>
          Our website may include hyperlinks to other websites not controlled by
          us. We suggest You exercise caution when clicking on a hyperlink.
          Although We use reasonable care in including a hyperlink on Our own
          web page, We do not regularly monitor the websites of these third
          parties, are not responsible for any damage or consequences You suffer
          by using these hyperlinks. We are not bound by the Privacy Policies of
          any third party website that You access by a hyperlink, nor are they
          bound by ours. We encourage You to read the Policies of those third
          party websites before interacting with them or making purchases. They
          may collect different information and by different methods than We do.
        </p>

        <p>
          <strong>Other purposes:</strong>
          We may disclose Your personal data as necessary to comply with any
          legal obligation or to protect Your interests, or the vital interests
          of others or Our company.
        </p>

        <h2>TRACKING TECHNOLOGIES</h2>
        <p>
          Cookies, Log Files and Web Beacons: Like many other Web sites, We
          makes use of log files. These files merely logs visitors to the site –
          usually a standard procedure for hosting companies and a part of
          hosting services’ analytics. The information inside the log files
          includes internet protocol (IP) addresses, browser type, Internet
          Service Provider (ISP), date/time stamp, referring/exit pages, and
          possibly the number of clicks. This information is used to analyze
          trends, administer the site, track user’s movement around the site,
          and gather demographic information. IP addresses and other such
          information are not linked to any information that is personally
          identifiable.
        </p>

        <p>
          We also use cookies - small text files sent to us by Your computer -
          and web beacons to store certain information. We may use cookies to
          authenticate Your identity, to determine if You are logged onto Our
          website, for personalization, for security, for targeted advertising,
          or for analysis of the performance of Our website and services. For
          example, cookies allow us to recommend blog posts to You based on what
          You have read on Our site in the past. We use cookies that are not
          specific to Your account but unique enough to allow us to analyze
          general trends and use, and to customize Your interaction with Our
          website.
        </p>

        <p>
          Most browsers are set to accept cookies by default. In addition, when
          You first encounter Our website, You will be asked to “consent to
          cookies.” If You wish to disable cookies, You may do so through Your
          individual browser options. However, this may affect Your ability to
          use or make purchases from Our website. More detailed information
          about cookie management with specific web browsers can be found at the
          browsers’ respective website,{" "}
          <a
            target="_blank"
            href="http://www.whatarecookies.com"
            rel="noreferrer"
          >
            What Are Cookies?
          </a>{" "}
          By continuing to use Our website and not disabling cookies on Your
          browser, You are consenting to Our use of cookies in accordance with
          the terms of this policy.
        </p>
        <h2>WEBSITE ANALYTICS</h2>
        <p>
          We may partner with third party analytic companies, including but not
          limited to Google Analytics. The analytic companies may also use
          cookies or other tracking technologies to analyze visitors’ use of Our
          website or mobile app to determine the popularity of the content, and
          better understand online activity. We do not transfer personal
          information to these third party vendors. However, in order to access
          Our website, You must consent to the collection and use of Your
          information by these third party analytic companies. You should review
          their Privacy Policy and contact them directly if You have questions.
          If You do not want any information to be collected and used by
          tracking technologies, visit the Network Advertising Initiative
          Opt-Out Tool or Digital Advertising Alliance Opt-Out Tool.
        </p>

        <h2>PROCESSING YOUR INFORMATION</h2>
        <p>
          For the most part, We do not process Your information in-house, but
          give it to third party processors for processing. For example, when
          PayPal takes Your payment information, they are a third party
          processor. They process Your payment and remit the funds to us. So in
          many instances, it will be necessary for us to transmit Your
          information to a third party processor, as We do not have the
          capability to perform these functions. More detail on third party
          processing is detailed below.
        </p>
        <ul>
          <li>
            Data associated with Your account, such as Your name, address, email
            address and payment information
          </li>
          <li>
            Data about Your usage of Our website, such as Your IP address,
            geographical information, and how long You accessed Our website and
            what You viewed.
          </li>
          <li>
            Data related to Your personal profile, such as Your name, address,
            profile picture, interests and hobbies, or employment details.
          </li>
          <li>Data that You provide us in the course of using Our services.</li>
          <li>
            Data that You post on Our website, such as comments or responses to
            blogs.
          </li>
          <li>
            Data that You submit to us when You make an inquiry regarding Our
            website or offerings.
          </li>
          <li>
            Data related to Your transactions with us, including Your purchase
            of Our goods or services. This information may include contact
            details and payment information.
          </li>
          <li>
            Data that You provide to us when You subscribe to Our emails or
            newsletters, including Your email address and contact information.
          </li>
          <li>
            Data that You submit to us via correspondence, such as when You
            email us with questions.
          </li>
          <li>
            Any other data identified in this policy, for the purpose of
            complying with Our legal obligations, or to protect the vital
            interests of You or any other natural person.
          </li>
        </ul>
        <h2>INTERNATIONAL DATA</h2>
        <p>
          Our website is hosted by servers located in the U.S. Therefore, if You
          reside in the European Union, some of Your data will be transferred
          internationally to those servers. Transfers will be protected by
          appropriate safeguards, namely the EU-US Privacy Shield. More
          information on the Privacy Shield can be found at:
          https://www.privacyshield.gov/welcome.
        </p>
        <h2>DATA RETENTION</h2>
        <p>
          We retain personal data as long as it is needed to to conduct Our
          legitimate business purposes or to comply with Our legal obligations,
          or until You ask us to delete Your data. For example, We will retain
          certain personal information indefinitely for the purposes of
          maintaining Your account, unless and until You delete Your account.
          Data that We gather for a specific and particular purpose, such as
          assisting law enforcement or analyzing trends, will not be kept for
          longer than is necessary for that particular purpose. Data that is no
          longer needed by us for any of the purposes listed above will be
          permanently deleted.
        </p>
        <p>
          You may request that We delete Your data at any time. However, note
          that We cannot control the retention policies of third parties. If You
          wish to have any third parties, including those to whom We’ve
          transmitted Your data, delete that data, You will need to contact
          those third parties directly. You may request from us a list of all
          third parties to whom We have transmitted Your data.
        </p>
        <h2>CHILDREN</h2>
        <p>
          This website is not designed for use by children under age 16, and We
          do not knowingly solicit personal data from anyone under age 16. If
          You are under age 16, do not access or use Our website or related
          products or services. If You become aware that We have collected data
          of anyone under the age of 16, please contact us so that We may delete
          that data.
        </p>
        <h2>YOUR RIGHTS</h2>
        <p>
          You have certain rights with respect to Your personal data, as
          outlined below. Note that We may charge You a reasonable fee for
          actions that You ask us to take with respect to Your data. In
          addition, We reserve the right to request that You provide us with
          evidence of Your identity before We take any action with respect to
          the exercise of Your data rights. Further, Your rights may be
          restricted or nullified to the extent they conflict with Our
          compelling business interests, the public interest, or the law.
        </p>
        <p>
          <strong>Update Account Information:</strong> You have the right to
          update or change any information You have provided to us. To update or
          delete Your information, please contact us at
        </p>
        <p>
          <strong>Confirm Personal Data and Its Use:</strong> You have the right
          to request that We confirm what data We hold about You, and for what
          purposes. You also have the right to confirmation of whether We
          process Your data or deliver Your data to third party processors, and
          for what purposes. We will supply You with copies of Your personal
          data unless doing so would affect the rights and freedoms of others.
        </p>
        <p>
          <strong>Change Consent:</strong> You have the right to change Your
          consent to Our use of Your information. In such cases, We may require
          You to delete Your account with us, as described above, and You may
          not have full access to Our website.
        </p>
        <p>
          <strong>Request a Copy of Data:</strong> You have the right to request
          a digital copy of the data that We hold about You. Your first request
          for a copy of Your personal data will be provided free of charge;
          subsequent requests will incur a reasonable fee.
        </p>

        <p>
          <strong>Transfer Your Data:</strong>
          You have the right to request that We gather and transfer Your data to
          another controller, in a commonly used and machine readable format,
          unless doing so would cause us an undue burden.
        </p>

        <p>
          <strong>Delete All Data:</strong>
          You have the right to request that We delete all data that We hold
          about You, and We must delete such data without undue delay. There are
          exceptions to this right, such as when keeping Your data is required
          by law, is necessary to exercise the right of freedom of expression
          and information, is required for compliance with a legal obligation,
          or is necessary for the exercise or defense of legal claims. Such a
          request may result in a termination of Your account with us and You
          may have limited or no use of Our website.
        </p>

        <p>
          <strong>Emails And Communications:</strong>
          You may opt out of receiving future email correspondence from us by
          checking the appropriate box when You register for an account or make
          a purchase. You may change Your communication settings by contacting
          us at <a href="mailto:office@keemove.com"> office@keemove.com</a>
        </p>

        <p>
          <strong>Marketing Communications:</strong>
          You may opt out of receiving any third party marketing communications
          or having Your personal information used for marketing purposes. You
          may do this by contacting us
        </p>

        <p>
          <strong>Processing:</strong>
          You may, in some circumstances restrict the processing of Your data,
          such as when You contest the accuracy of Your data or when You have
          objected to processing, pending the verification of that objection.
          When processing has been restricted, We will continue to store Your
          data but will not pass it on to third party processors without Your
          consent, or as necessary to comply with legal obligations or protect
          Your rights or those of others or Our company. In addition, You may
          opt out of any processing of Your data altogether. Note however that
          doing so may result in the termination of Your account and loss of
          access to Our website.
        </p>

        <p>
          <strong>Complaints:</strong>
          You have the right to complain to a supervising authority if You
          believe We are misusing Your data or have violated any of Your rights
          under this Privacy Policy or applicable law.
        </p>

        <h2>CALIFORNIA PRIVACY RIGHTS</h2>

        <p>
          The State of California has established its own unique regulations
          that apply to California residents. If You reside in California, You
          have the right to obtain from us, once per year and free of charge,
          information regarding what information We disclose to third party
          marketers, and the names and addresses of each third party to whom We
          disclose Your data. If You are a California resident and would like to
          make such a request, please use the contact information listed below.
        </p>

        <p>
          If You are a California resident and under the age of 18, You have the
          right to request that We remove any data that You publicly post on Our
          website. To request removal of Your data, please use the contact
          information listed below. Note that while We will remove Your data
          that is publicly posted on Our website, We may not be able to
          completely remove that data from Our systems.
        </p>
        <h2>NEVADA PRIVACY RIGHTS</h2>
        <p>
          Residents of the State of Nevada have the right to opt out of the sale
          of certain pieces of their information to third parties who will sell
          or license their information to others. If you are a Nevada resident
          and would like to make such a request, please email{" "}
          <a href="mailto:office@keemove.com"> office@keemove.com</a>
        </p>

        <h2>NEWSLETTER PRIVACY</h2>
        <p>
          We offer the opportunity for You to volunteer certain information to
          us that is used for email and marketing purposes. This information
          includes, but is not limited to, Your name and email. You will have an
          opportunity to unsubscribe from any future communications via email,
          but We reserve the right to maintain a database of past email
          subscribers. We reserve the right to use this information as
          reasonably necessary in Our business and as provided by law. Your
          information will be shared with reasonably necessary parties for the
          ordinary course of conducting Our business, such as through Facebook
          ads or Google Pay Per Click marketing campaigns.
        </p>

        <h2>DATA BREACH PROCEDURES</h2>
        <p>
          We take all reasonable steps to protect Your personal data and keep
          Your information secure. We use recognized online secure payment
          systems and implement generally accepted standards of security to
          protect against personal data loss or misuse. However, no security
          measure is foolproof, and no method of data transmission can be
          guaranteed against interception or misuse. We cannot guarantee
          complete security of any information You transmit to us.
        </p>

        <p>
          By consent to this Privacy Policy, You acknowledge that Your personal
          data may be available, via the internet, around the world. We cannot
          prevent the use or misuse of Your data by other parties.
        </p>

        <p>
          In the unlikely event customer data has been lost, stolen, or
          potentially compromised, Our policy is to alert our customers via
          email no later than 72 hours of Our company becoming aware of the
          event. We will also report such incident to any required data
          protection authority. We will work closely with any customers affected
          to determine next steps such as any end-user notifications, needed
          patches, and how to avoid any similar event in the future.
        </p>

        <h2>PRIVACY POLICY CHANGES</h2>
        <p>
          Although most changes are likely to be minor, We may change our
          Privacy Policy from time to time, and in Our sole discretion. We will
          notify clients by email when making changes.
        </p>

        <h2>SMS TERMS &amp; CONDITIONS</h2>

        <p>
          <strong>SMS Consent Communication: </strong>
          We will not share your phone number with any third parties for
          marketing purposes.
        </p>

        <p>
          <strong>Types of SMS Communications: </strong>
          If you opt in to receive messages from Kee Move LLC, you may receive
          text messages for conversational purposes, including appointment
          confirmations, appointment cancellations, and weather-related updates.
          Standard message rates may apply.
        </p>

        <p>
          <strong>Example Message: </strong>
          &quot;Hello, this is a friendly reminder of your upcoming appointment
          with Raeleah Schaeffer at [Location] on [Date] at [Time]. You can
          reply STOP to opt out of SMS messaging from Kee Move LLC at any
          time.&quot;
        </p>

        <p>
          <strong>Message Frequency: </strong>
          You may receive approximately 3 SMS messages per week.
        </p>

        <p>
          <strong>Carrier Charges: </strong>
          Message and data rates may apply based on your mobile carrier and
          location.
        </p>

        <p>
          <strong>Opt-In Methods: </strong>
          You can opt in to receive SMS messages from Kee Move LLC verbally. We
          obtain consent by asking: &quot;Do you agree to receive conversational
          text messages from Kee Move LLC? Reply STOP to opt out; reply HELP for
          support; message and data rates may apply; messaging frequency may
          vary. Visit{" "}
          <a href="https://www.keemove.com/privacy/#privacy">
            https://www.keemove.com/privacy/#privacy
          </a>{" "}
          to view our Privacy Policy and Terms of Service.&quot;
        </p>

        <p>
          <strong>Opt-Out Instructions: </strong>
          You may opt out at any time by replying &quot;STOP&quot; to any
          message. To resume receiving text messages, reply &quot;START.&quot;
        </p>

        <p>
          <strong>Help: </strong>
          If you need assistance, reply &quot;HELP&quot; or contact us at{" "}
          <a href="https://www.keemove.com/#home">
            https://www.keemove.com/#home
          </a>
        </p>

        <p>
          <strong>Disclosures: </strong>
          Message frequency may vary. Message and data rates may apply. Reply
          &quot;STOP&quot; to cancel. Reply &quot;HELP&quot; for assistance.
          Visit our{" "}
          <a href="https://www.keemove.com/privacy/#privacy">
            Privacy Policy
          </a>{" "}
          and Terms and Conditions pages for more information.
        </p>
      </div>
    </div>
  );
};

export default Privacy;
